import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  outside(event) {
    if (!this.element.contains(event.target)) this.reset()
  }

  close(event) {
    if (!this.element.open) return
    event.stopPropagation()
    this.reset()
    this.element.querySelector("summary").focus()
  }

  reset() { this.element.open = false }
}
